/**
 * Runs before any other module of the app is evaluated: `main.tsx` imports it
 * first, and ES modules evaluate in import order.
 *
 * An operator's view of a member (task 394) arrives as
 * `/impersonate#<session>`. The session has to leave the URL before anything
 * else runs, and the tab has to know it is an impersonation before any module
 * reads storage — the persisted stores hydrate when their modules load, so a
 * call in `main.tsx`'s body would come after `App`'s imports had already bound
 * them to the operator's own `localStorage`.
 */

import { bootImpersonation } from "./lib/auth/impersonation";

bootImpersonation();
